const Card = () => {
  const body = document.querySelector('body');
  const cards = document.querySelectorAll('.card');
  const breakpoint = body.getAttribute('data-breakpoint');
  let timeout;
  let windowResize = null;

  handleCardGTMTracking();
  function handleCardGTMTracking() {
    cards.forEach(item => {
      const cardLinks = item.querySelectorAll('a');
      const cardContentTypeElem = item.querySelector('.card__link-cover');
      const cardTitleElem = item.querySelector('.card__title-content');

      if (cardLinks && cardContentTypeElem && cardTitleElem) {
        const cardContentType = cardContentTypeElem.getAttribute('data-post-type');
        const cardTitle = cardTitleElem.textContent.trim();

        cardLinks.forEach(linkItem => {
          linkItem.addEventListener('keydown', e => {
            const key = e.key || e.keyCode;

            if (key === 13 || key === 'Enter') {
              linkItem.click();
            }
          });

          if (! linkItem.hasAttribute('download') && ! item.parentElement.classList.contains('saved-contents__card-item') && ! item.parentElement.classList.contains('hub-result__list-item--search')) {
            const cardDataLayer = {
              event: 'recirculation',
              eventType: 'content card click',
              cardContentType,
              cardTitle,
            };

            if (linkItem.parentElement.classList.contains('card--event')) {
              cardDataLayer.foxEventType = linkItem.getAttribute('data-event-type');
            }

            linkItem.addEventListener('click', () => {
              window.dataLayer.push(cardDataLayer);
            });
          }

          if (item.parentElement.classList.contains('hub-result__list-item--search')) {
            linkItem.addEventListener('click', () => {
              window.dataLayer.push({
                event: 'recirculation',
                eventType: 'search result click',
                searchTerms: cardTitle,
              });
            });
          }

          if (item.parentElement.classList.contains('saved-contents__card-item') && ! item.classList.contains('card--walkthrough')) {
            linkItem.addEventListener('click', () => {
              window.dataLayer.push({
                event: 'profile',
                eventType: 'saved content card click',
                cardTitle,
              });
            });
          }

          if (item.classList.contains('card--walkthrough') || item.classList.contains('card--announcement')) {
            linkItem.addEventListener('click', e => {
              window.dataLayer.push({
                event: 'profile',
                eventType: e.target.getAttribute('data-card-action'),
                cardTitle: e.target.getAttribute('data-card-title'),
                cardType: e.target.getAttribute('data-card-type'),
              });
            });
          }
        });
      }
    });
  }

  function cardsAccessibility(card) {
    card.querySelector('.card__link').setAttribute('tabindex', '-1');
  }

  function cardsRemoveTabIndex(card) {
    if (body.getAttribute('data-breakpoint') !== 'desktop') {
      card.querySelector('.card__link').removeAttribute('tabindex');
    }
  }

  if (breakpoint === 'desktop') {
    cards.forEach(card => {
      const cardLink = card.querySelector('.card__link-cover');

      if (! cardLink) {
        return false;
      }

      cardLink.addEventListener('mouseover', () => {
        timeout = setTimeout(() => {
          card.classList.add('card--is-hovered');
        }, 250);
      });

      cardLink.addEventListener('mouseout', () => {
        card.classList.remove('card--is-hovered');
        clearTimeout(timeout);
      });

      cardsAccessibility(card);
      window.addEventListener('resize', function() {
        // clear the timeout
        clearTimeout(windowResize);
        // start timing for event "completion"
        windowResize = setTimeout(cardsRemoveTabIndex(card), 350);
      });
    });
  }
};

export default Card;
